import React, {memo} from 'react';
import {useParams} from "react-router-dom";

import {CHAIN_ID, TRANSACTION_HISTORY_SECTION} from "utils";
import {NETWORK_ID} from "web3/chains";

import {TransactionHistorySection} from "components/molecules";
import {Accordion} from "components/atoms";

const BazaarCurrentItemTransactions = () => {
    const {token_id, network} = useParams()

    const chainId = NETWORK_ID[network] ?? CHAIN_ID.BASE_MAINNET

    return (
        <Accordion
            open={true}
            title="activity"
            icon="activities"
        >
            <TransactionHistorySection
                data={{token_id, chain_id: chainId}}
                transactionHistorySection={TRANSACTION_HISTORY_SECTION.INVENTORY_ACTIVITY}
            />
        </Accordion>
    )
}

export default memo(BazaarCurrentItemTransactions)